import { request } from './http';

export async function getTableData(tableName, options = {}) {
    const queryParams = new URLSearchParams();
    const wantsPage = options.page != null || options.limit != null || options.offset != null;
    if (options.all || !wantsPage) {
      queryParams.set('all', '1');
    } else {
      if (options.page != null) queryParams.set('page', String(options.page));
      if (options.limit != null) queryParams.set('limit', String(options.limit));
      if (options.offset != null) queryParams.set('offset', String(options.offset));
    }
    return request(`/data/${tableName}?${queryParams}`);
  }

export async function enrichRaciExportRows(rows) {
    return request('/data/enrich-raci-rows', {
      method: 'POST',
      body: JSON.stringify({ rows: rows || [] })
    });
  }

export async function getTableRecord(tableName, id) {
    return request(`/data/${tableName}/${id}`);
  }

export async function saveDrainageRecordation(data) {
    return request('/drainage-recordation', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function deleteDrainageRecordation(id) {
    return request(`/drainage-recordation/${id}`, {
      method: 'DELETE',
    });
  }

export async function deleteSpccAnnual(id) {
    return request(`/spcc-annual/${id}`, { method: 'DELETE' });
  }

export async function deleteSpccRoutine(id) {
    return request(`/spcc-routine/${id}`, { method: 'DELETE' });
  }

export async function deleteSwpppQuarterly(id) {
    return request(`/swppp-quarterly/${id}`, { method: 'DELETE' });
  }

export async function deleteSwpppDischargeMonitoring(id) {
    return request(`/swppp-discharge-monitoring/${id}`, { method: 'DELETE' });
  }

export async function deleteSumpPumpMaintenance(id) {
    return request(`/sump-pump-maintenance/${id}`, { method: 'DELETE' });
  }

export async function deleteTransferHosePipeTesting(id) {
    return request(`/transfer-hose-pipe-testing/${id}`, { method: 'DELETE' });
  }

export async function deleteResponseEquipmentInventory(id) {
    return request(`/inspections/response-equipment/${id}`, { method: 'DELETE' });
  }

export async function deleteEnvironmentalSampling(id) {
    return request(`/testing/environmental-sampling/${id}`, { method: 'DELETE' });
  }

export async function deleteEnvironmentalLabAnalysis(id) {
    return request(`/testing/environmental-lab-analysis/${id}`, { method: 'DELETE' });
  }

export async function saveSWPPPDischargeMonitoring(data) {
    return request('/swppp-discharge-monitoring', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function saveSWPPPQuarterly(data) {
    return request('/swppp-quarterly', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function saveSPCCAnnual(data) {
    return request('/spcc-annual', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function saveSPCCRoutine(data) {
    return request('/spcc-routine', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function saveSumpPumpMaintenance(data) {
    return request('/sump-pump-maintenance', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function generateSumpPumpMaintenancePdf(recordId) {
    return request('/pdf/generate-and-save-sump-pump-maintenance', {
      method: 'POST',
      body: JSON.stringify({ recordId }),
    });
  }

export const genericTableOperationsApi = {
  getTableData,
  enrichRaciExportRows,
  getTableRecord,
  saveDrainageRecordation,
  deleteDrainageRecordation,
  deleteSpccAnnual,
  deleteSpccRoutine,
  deleteSwpppQuarterly,
  deleteSwpppDischargeMonitoring,
  deleteSumpPumpMaintenance,
  deleteTransferHosePipeTesting,
  deleteResponseEquipmentInventory,
  deleteEnvironmentalSampling,
  deleteEnvironmentalLabAnalysis,
  saveSWPPPDischargeMonitoring,
  saveSWPPPQuarterly,
  saveSPCCAnnual,
  saveSPCCRoutine,
  saveSumpPumpMaintenance,
  generateSumpPumpMaintenancePdf,
};

